import { useState, useEffect } from 'react';

import FacilityLscData from './FacilityLscData';

const useFacilityLscData = (facilityId) => {
  const [facilityLscState, setFacilityLscState] = useState(FacilityLscData.INITIAL_STATE);
  const getFacilityLsc = (facilityId) => FacilityLscData.getFacilityLscData(facilityId, facilityLscState, setFacilityLscState);

  useEffect(() => {
    if (facilityId > 0 && facilityLscState.facilityId !== facilityId) {
      getFacilityLsc(facilityId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityId, facilityLscState.facilityId, facilityLscState.isArrayLoaded]);

  return {
    facilityLscState,
    getFacilityLsc
  };
};

export default useFacilityLscData;
